import { Controller } from "@hotwired/stimulus"

// Tiny controller on the project sidebar that signals when the sidebar
// updates (project switch, folder switch, item added). The main
// project--items controller listens for this event to refresh checkmarks.
export default class extends Controller {
  static values = { folderId: Number }

  connect() {
    this.notifyUpdate()
  }

  folderIdValueChanged() {
    this.notifyUpdate()
  }

  notifyUpdate() {
    document.dispatchEvent(new CustomEvent('project-items:sidebar-updated'))
  }
}
